module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table/table-body/table-body.component.html
// module id = ../../../../../src/app/shared/components/table/table-body/table-body.component.html
// module chunks = 12